import { createSlice } from "@reduxjs/toolkit";
import { SocialMarketPartnerState } from "./types";
import { ErrorType } from "@/shared/types";
import { fetchTradingPartner } from "./social-market-partner-thunk";

const initialState: SocialMarketPartnerState = {
    partner: {
        id: "",
        bot_id: "",
        name: "",
        logo: "",
        description: "",
        href: "",
        inn: "",
        wallet_id: ""
    },
    isLoading: false,
    partnerError: null
}

const socialMarketPartnerSlice = createSlice({
    name: 'socialMarketPartner',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchTradingPartner.pending, (state) => {
            state.isLoading = false
        })
        .addCase(fetchTradingPartner.fulfilled, (state, action) => {
            state.partnerError = null
            state.partner = action.payload
            state.isLoading = false
        })
        .addCase(fetchTradingPartner.rejected, (state, action) => {
            state.partnerError = action.payload as ErrorType ?? null
            state.isLoading = false
        })
    },
})

export default socialMarketPartnerSlice.reducer